import { Badge, BadgeProps, Color, Text } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProductConnectivityState, titleForProductConnectivityState } from 'zens-store'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  unknown: {
    color: Color.metalGrey,
  },
})

interface Props extends Omit<BadgeProps, 'status'> {
  value?: ProductConnectivityState
}
const Connectivity = (props: Props) => {
  const { value, ...otherProps } = props
  const { t } = useTranslation()
  const title = titleForProductConnectivityState(value, t)

  switch (value) {
    case ProductConnectivityState.Connected:
      return <Badge title={title} status="success" {...otherProps} />
    case ProductConnectivityState.ConnectivityLost:
      return <Badge title={title} status="warning" {...otherProps} />
    case ProductConnectivityState.Disconnected:
      return <Badge title={title} status="error" {...otherProps} />
    case ProductConnectivityState.NeverOnline:
      return <Badge title={title} status="inactive" {...otherProps} />
    default:
      return <Text style={styles.unknown}>{title}</Text>
  }
}

export default Connectivity
